module.exports = {
  AUTO: 'auto',
  RASTER: 'raster',
  VECTOR: 'vector'
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/render-modes.js
// module id = 1022
// module chunks = 6